const addKeys = (arr, propertyName) => {
  return arr.map((item, index) => ({
    ...item,
    key: propertyName ? item[propertyName] : index
  }));
};

export {addKeys}